import { Component, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../../../animations/form-error';
import { BasePageComponent } from '../../../../../base-page';
import { ChampsFormulaire, SourceType } from '../../../../../../model/champs_formulaire/champs-formulaire.model';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { IOption } from '../../../../../../ui/interfaces/option';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IValidatorAffectedColumnName, ValidatorAffectedColumnName } from '../../../validator_affected/validator-affected-column-name';
import { Validators as ValidatorsModel } from '../../../../../../model/champs_formulaire/validators.model';
import { Router } from '@angular/router';
import { ValidatorService } from '../../../validators/validator.service';
import { ServiceItemService } from '../../../../service-items/service-item.service';
import { ChampsFormulaireService } from '../../champs-formulaire.service';
import { ValidatorAffectedService } from '../../../validator_affected/validator-affected.service';
import { BaseService } from '../../../../base/base.service';
import { AccountService } from '../../../../../../services/ServiceEntity/account.service';
import { FormService } from '../../../../../../shared/services/form.service';
import { TCModalService } from '../../../../../../ui/services/modal/modal.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../../../interfaces/app-state';
import { HttpService } from '../../../../../../services/http/http.service';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { TIME_MIN_REQUEST } from '../../../../../../shared/constant/request.contant';
import { ConstantValidatorsAffected } from '../../../validator_affected/validator-affected.url';
import { ConstantChampsFormulaires } from '../../champs-formulaire.url';
import { FormValidator } from '../../../../../../model/champs_formulaire/form-validator.model';
import { ISourceFormColumnName, SourceFormColumnName } from '../../../source-form/source-form-column-name';
import { SourceFormService } from '../../../source-form/source-form.service';
import { NameSourceFType, SourceFormModel } from '../../../../../../model/champs_formulaire/source-form.model';
import { ConstantSourceForm } from '../../../source-form/source-form.url';

/**
 * Permet de gérer l'ajout des countries.
 */
@Component({
  selector: 'app-source-form-add',
  templateUrl: './source-form-add.component.html',
  animations: [fadeIn]
})
export class SourceFormAddComponent extends BasePageComponent
  implements OnInit, OnDestroy {
  isSaving = false;
  successSave = false;
  serverHasError = false;

  formSelected: ChampsFormulaire;
  theDialogRef: MatDialogRef<SourceFormAddComponent>;
  private subs$ = new Subject<void>();
  typeForms: IOption[] = [];
  sourceTypes: IOption[] = [];
  nameSourceFType: IOption[] = [];

  editForm: UntypedFormGroup;
  column: ISourceFormColumnName;

  validatorsList: ValidatorsModel[] = [];
  filteredOptions: Observable<ValidatorsModel[]>;

  constructor(
    private router: Router,
    private validatorService: ValidatorService,
    private serviceItemService: ServiceItemService,
    private formulaireService: ChampsFormulaireService,
    private SourceFormService: SourceFormService,
    public baseService: BaseService,
    private accountService: AccountService,
    private formService: FormService,
    private dialogRef: MatDialogRef<SourceFormAddComponent>,
    private columnName: SourceFormColumnName,
    private fb: UntypedFormBuilder,
    private modal: TCModalService,
    store: Store<IAppState>, httpSv: HttpService) {
    super(store, httpSv);
    console.log('## construct source form add validator');
    const column = this.columnName.getColumnName();
    this.theDialogRef = this.dialogRef;
    this.column = column;
    this.initForm(fb, column);
  }

  ngOnInit(): void {
    console.log('## init source form add validator');
    this.accountService.identity().pipe(takeUntil(this.subs$))
      .subscribe(account => {
        this.formulaireService.getObjetSelectObs()
          .pipe(takeUntil(this.subs$)).subscribe((res: ChampsFormulaire) => {
          console.log('## get formulaire selected to liste');
          try {
            console.log('## data: ', res);
            this.formSelected = res;
            this.editForm.patchValue({
              [this.column.champsFormulaire]: res.label,
              [this.column.source]: res.sourceType ?
                res.sourceType.toString().toLocaleLowerCase() : '',
            });
          } catch (e) {
            console.log('## error get country selected: ' + e.message);
          }
        });
        super.setLoaded();
      });
    for(let item in SourceType) {
      if(isNaN(Number(item))) {
        this.sourceTypes.push({
          ...new Option(),
          label: item?.toLocaleLowerCase(),
          value: item?.toString()
        })
      }
    }
    for(let item in NameSourceFType) {
      if(isNaN(Number(item))) {
        this.nameSourceFType.push({
          ...new Option(),
          label: item?.toLocaleLowerCase(),
          value: item?.toString()
        })
      }
    }
  }

  ngOnDestroy() {
    console.log('## destroy country add');
    this.formService.free(this.subs$);
    this.successSave = false;
  }


  displayFnF(subject: ChampsFormulaire) {
    return subject ? subject.label : '';
  }

  initForm(fb: UntypedFormBuilder, column: ISourceFormColumnName) {
    if (fb && column) {
      this.editForm = fb.group({
        [column.nameSourceFType]: ['', [Validators.required]],
        [column.valeur]: ['', [Validators.required]],
        [column.comment]: [''],
        [column.source]: [''],
        [column.champsFormulaire]: [''],
      });
    }
  }

  /**
   * Enregistre un type de account ressource.
   */
  save() {
    console.log('## save validator');
    this.isSaving = true;
    this.successSave = false;
    this.serverHasError = false;
    const c = this.createFromForm();
    console.log('## c: ', c);
    this.SourceFormService.create(c,
      this.SourceFormService.resourceUrl)
      .subscribe(res => {
          console.log('## success create validator');
          this.serverHasError = false;
          this.responseFromServer();
          this.editForm.reset();
          this.successSave = true;
          this.router.navigate(['/' + ConstantSourceForm.urlFull.FEES.LIST],
            { queryParams: { [ConstantChampsFormulaires.url.FEES.FEES_]: this.formSelected.id } });
        },
        err => {
          console.log('## error create validator: ', err);
          this.responseFromServer();
          this.serverHasError = true;
          this.successSave = false;
        });
  }

  responseFromServer() {
    setTimeout(() => {
      this.isSaving = false;
    }, 300);
  }

  private createFromForm(): SourceFormModel {
    return {
      ...new SourceFormModel(),
      nameSourceFType: this.editForm.get([this.column.nameSourceFType]).value,
      valeur: this.editForm.get([this.column.valeur]).value,
      comment: this.editForm.get([this.column.comment]).value,
      champsFormulaireId: this.formSelected.id
    };
  }

  closeModal() {
    console.log('## close formulaire add');
    this.dialogRef.close();
    this.successSave = false;
    this.serverHasError = false;
    this.editForm.reset();
  }

  reset() {
    this.editForm.reset();
  }


}